export default __webpack_public_path__ + "static/media/dj-mixer.64982427.png";